module.exports = __webpack_public_path__ + "img/formassembly.777adb3d.svg";